import { render, staticRenderFns } from "./AdminOrgLayout.vue?vue&type=template&id=6bde15ca&scoped=true&"
import script from "./AdminOrgLayout.vue?vue&type=script&lang=js&"
export * from "./AdminOrgLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgLayout.vue?vue&type=style&index=0&id=6bde15ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde15ca",
  null
  
)

export default component.exports